import { KeycloakService } from './../shared/services/keycloak.service';
import * as config from '../environments/environment';

export const initializeKeycloak = (keycloak: KeycloakService) => async () =>
    keycloak.init(
        {
            url: config.environment.keycloak.url,
            realm: config.environment.keycloak.realm,
            clientId:
                !window.location.hostname.includes('staging') &&
                !window.location.hostname.includes('development')
                    ? config?.environment?.keycloak?.clientId?.replace(
                          'Staging',
                          '',
                      )
                    : config.environment.keycloak.clientId,
        },
        {
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri:
                window.location.origin + '/assets/silent-check-sso.html',
            checkLoginIframe: false,
            redirectUri:
                !window.location.hostname.includes('staging') &&
                !window.location.hostname.includes('development')
                    ? config.environment.bildverifizierungUrl.replace(
                          '-staging',
                          '',
                      )
                    : config.environment.bildverifizierungUrl,
        },
    );
